import { TaskStates } from "../enums/TaskStates";

export class vwTaskReadinessItem {

  TypeId : number;
  DateValue : string;
  ReadinessCode: TaskStates;   // InProgress, Ready, Accepted
}
